import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDownOutline } from 'ionicons/icons';
import './BreadcrumbDropdown.css';

/**
 * BreadcrumbDropdown - Reusable dropdown for breadcrumb navigation
 * 
 * @param {string} label - The breadcrumb label to display
 * @param {boolean} isActive - Whether this is the last/active breadcrumb
 * @param {function} onFetch - Function to fetch items when hovering
 * @param {array} items - Array of dropdown items
 * @param {boolean} loading - Loading state
 * @param {function} onItemClick - Click handler for items (receives item)
 * @param {function} onLabelClick - Click handler for the label itself
 * @param {function} getItemLabel - Function to extract label from item
 * @param {function} getItemKey - Function to extract unique key from item
 * @param {string} emptyMessage - Message when no items
 * @param {string} headerLabel - Header label for dropdown
 */
const BreadcrumbDropdown = ({
  label,
  isActive = false,
  onFetch,
  items = [],
  loading = false,
  onItemClick,
  onLabelClick,
  getItemLabel,
  getItemKey,
  emptyMessage = 'No items',
  headerLabel = 'ITEMS',
  isProject = false,
  isCollection = false
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleMouseEnter = () => {
    if (!showDropdown && onFetch) {
      onFetch();
      setShowDropdown(true);
    }
  };

  const handleMouseLeave = () => {
    setShowDropdown(false);
  };

  const handleLabelClick = () => {
    setShowDropdown(false);
    if (onLabelClick) {
      onLabelClick();
    }
  };

  const handleItemClick = (item) => {
    setShowDropdown(false);
    if (onItemClick) {
      onItemClick(item);
    }
  };

  return (
    <div 
      className="breadcrumb-dropdown-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span 
        className={`breadcrumb-item ${isActive ? 'active' : 'inactive'} ${isProject ? 'breadcrumb-project' : ''} ${isCollection ? 'breadcrumb-collection' : ''}`}
        onClick={handleLabelClick}
      >
        {label}
        <IonIcon icon={chevronDownOutline} className="dropdown-icon" />
      </span>
      
      {showDropdown && (
        <div className="breadcrumb-dropdown-menu">
          <div className="dropdown-header">{headerLabel}</div>
          <div className="dropdown-content">
            {loading ? (
              <>
                <div className="dropdown-skeleton-item">
                  <div className="skeleton-line" />
                </div>
                <div className="dropdown-skeleton-item">
                  <div className="skeleton-line" />
                </div>
                <div className="dropdown-skeleton-item">
                  <div className="skeleton-line" />
                </div>
              </>
            ) : items.length > 0 ? (
              items.map((item) => (
                <div
                  key={getItemKey(item)}
                  className="dropdown-item"
                  onClick={() => handleItemClick(item)}
                >
                  {getItemLabel(item)}
                </div>
              ))
            ) : (
              <div className="dropdown-item disabled">{emptyMessage}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BreadcrumbDropdown;

